import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "./../utils/errors"
const urlDocument = "Document";

//* Api / Document/Package/UpdateWallet
export const updateWalletDocument = async ({ idCatDocumentoPaquete, Nombre, Imagen }) => {
    return await axios.put(`${APIURL}/${urlDocument}/Package/UpdateWallet`, {
        idCatDocumentoPaquete,
        Nombre,
        Imagen
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return { status: 500 }
    })
}

export const deleteWalletDocument = async ({ idCatDocumentoPaquete }) => {
    return await axios.delete(`${APIURL}/${urlDocument}/DeletePackage/${idCatDocumentoPaquete}`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return { status: 500 }
    })
}
//* Api para obtener documentos del wallet
//* Api /Document/Package/AddWallet
export const postWalletDocument = async ({ idPaquete, Nombre, Imagen }) => {
    return await axios.post(`${APIURL}/${urlDocument}/Package/AddWallet`, {
        idPaquete,
        Nombre,
        Imagen
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return { status: 500 }
    })
}

export const getWalletDocument = async ({ idCatDocumentoPaquete }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Wallet/Download/${idCatDocumentoPaquete}`,
        {
            headers: getCabecera(),
            responseType: "arraybuffer"
        })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            // return getError(Error);
            return { status: 500 }
        })
}

export const getWallet = async ({ idPaquete }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Wallet/${idPaquete}`,
        {
            headers: getCabecera()
        })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            // return getError(Error);
            return []
        })
}

//TODO Servicios finanzas
export const postComprobantePagoIndividual = async ({ idCompra, Imagen, Extension, Nombre }) => {
    return await axios.post(`${APIURL}/${urlDocument}/Package/Voucher/Individual/${idCompra}`, {
        Imagen,
        Extension,
        Nombre
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error)
    })
}
export const postComprobantePagoGrupal = async ({ idPagoGrupal, Imagen, Extension, Nombre }) => {
    return await axios.post(`${APIURL}/${urlDocument}/Package/Voucher/Group/${idPagoGrupal}`, {
        Imagen,
        Extension,
        Nombre
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error)
    })
}

//TODO Servicios Admin Item
export const getDocuemtVoucher = async ({ idPaquete }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/${idPaquete}`,
        {
            headers: getCabecera()
        })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            // return getError(Error);
            return []
        })
}
//TODO: Metodos para descargar comprobantes de pago
export const getDocuemtVoucherDowload = async ({ idCompra }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Download/${idCompra}`,
        {
            headers: getCabecera(),
            responseType: "arraybuffer"
        })
        .then((Response) => {
            return { contentType: Response.headers["content-type"], data: Response.data };
        })
        .catch((Error) => {
            return getError(Error);
        })
}

export const getDocuemtVoucherGrupalCompra = async ({ idPagoGrupal }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Group/Download/${idPagoGrupal}`,
        {
            headers: getCabecera(),
            responseType: "arraybuffer"
        })
        .then((Response) => {
            return { contentType: Response.headers["content-type"], data: Response.data };
        })
        .catch((Error) => {
            return getError(Error);
        })
}
/**
 * TODO: Api para Voucher de compra
 */
export const getVoucherCompraIndividual = async ({ idCompra }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Individual/${idCompra}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}

export const getVoucherCompraIndividualDowload = async ({ idDocumento }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Individual/Download/${idDocumento}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data };
    }).catch((Error) => {
        return getError(Error);
    })
}

export const deleteVoucherCompraIndividualDocumento = async ({ idDocumento }) => {
    return await axios.delete(`${APIURL}/${urlDocument}/Package/Voucher/Individual/Delete/${idDocumento}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

export const getVoucherCompraGrupal = async ({ idCompra }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Group/${idCompra}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}

export const getVoucherCompraGrupalDowload = async ({ idDocumento }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Package/Voucher/Group/Download/${idDocumento}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data };
    }).catch((Error) => {
        return getError(Error);
    })
}

export const deleteVoucherCompraGrupalDocumento = async ({ idDocumento }) => {
    return await axios.delete(`${APIURL}/${urlDocument}/Package/Voucher/Group/Delete/${idDocumento}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Apis para consulta de documentos estado de cuenta devoluciones doc
export const getEstadoCuentaDevolucionDowload = async ({ IdDevolucionSolicitud }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Refound/BankStatement/${IdDevolucionSolicitud}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data };
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Cargar comprobante pago de rembolso doc
//* POST /api/Document/Refound/Voucher
export const postCargarVoucherRembolso = async ({ IdDevolucionSolicitud, Nombre, Imagen, Extension }) => {
    return await axios.post(`${APIURL}/${urlDocument}/Refound/Voucher`, {
        IdDevolucionSolicitud,
        Nombre,
        Imagen,
        Extension,
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error)
    })
}

//* Consultar comprobante de rembolso doc
//* GET /api/Document/Refound/Voucher/{IdDevolucionComprobante}
export const getVoucherDevolucion = async ({ IdDevolucionComprobante }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Refound/Voucher/${IdDevolucionComprobante}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data }
    }).catch((Error) => {
        return getError(Error)
    })
}
//* Eliminar comprobante de rembolso doc
//* DELETE /api/Document/Refound/Voucher/{IdDevolucionComprobante}
export const deleteVoucherDevolucion = async ({ IdDevolucionComprobante }) => {
    return await axios.delete(`${APIURL}/${urlDocument}/Refound/Voucher/${IdDevolucionComprobante}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}

//* Apis para consulta de documentos estado de cuenta devoluciones doc
//* GET /api/Document/Invoice/TaxStatus/{IdFactura}
export const getComprobanteFiscalClienteDowload = async ({ IdFactura }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Invoice/TaxStatus/${IdFactura}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data };
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Cargar factura doc
//* POST /api/Document/Invoice
export const postCargarFactura = async ({ IdFactura, Nombre, Imagen, Extension }) => {
    return await axios.post(`${APIURL}/${urlDocument}/Invoice`, {
        IdFactura,
        Nombre,
        Imagen,
        Extension,
    }, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error)
    })
}
//* Consultar factura doc
//* GET /api/Document/Invoice/{IdFacturaComprobante}
export const getFactura = async ({ IdFacturaComprobante }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Invoice/${IdFacturaComprobante}`, {
        headers: getCabecera(),
        responseType: "arraybuffer"
    }).then((Response) => {
        return { contentType: Response.headers["content-type"], data: Response.data }
    }).catch((Error) => {
        return getError(Error)
    })
}
//* Eliminar factura doc
//* DELETE /api/Document/Invoice/{IdFacturaComprobante}
export const deleteFactura = async ({ IdFacturaComprobante }) => {
    return await axios.delete(`${APIURL}/${urlDocument}/Invoice/${IdFacturaComprobante}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}
//* Conultar INE por cotizacion
//* Get /api/Document/Quote/Ine/{IdCotizacion}
export const getIneCotizaicion = async ({ idCotizacion }) => {
    return await axios.get(`${APIURL}/${urlDocument}/Quote/Ine/${idCotizacion}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        //return getError(Error)
        return []
    })
}